import BaseService from './Base';

class WorkOrderCVService extends BaseService {
  static endpoint = 'api/2.0/custom-values/';
}

export default WorkOrderCVService;